<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="tab-info-card">
        <div class="user-detail">
          <div class="tab-info-title tab-info-title-flex">
            <span>基本信息</span>
            <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_GOODSEVALUATION:DELETE'">
              <el-button type="danger" size="mini" @click="deleteEval">删除</el-button>
            </wt-auth>
          </div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">评价人昵称：</span>
              <span class="tab-base-value">{{detailFormData.nickName}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">评价时间：</span>
              <span class="tab-base-value">{{detailFormData.createTime}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">商品名称：</span>
              <span class="tab-base-value normal-status" style="font-weight: 700;cursor: pointer;color: #108ee9;"  @click="toClickAction">{{detailFormData.goodsName}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- tab内容 -->
      <wt-detail-form-section class="tab-info-card" ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" >
        <template slot="score" slot-scope="data">
         <el-rate v-model="detailFormData.score" disabled></el-rate>
        </template>
      </wt-detail-form-section>
    </div>
    <wt-detail-page  :visible.sync="goodsVisible" :component-name="goodsComponentName" component-type="view" />
    <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'GoodsEvaluation-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USERMESSAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userMessage/userMessageUpdate',
      formAddUrl: '/modules/userMessage/userMessageAdd',
      detailFormButtons: {
        title: '评价详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      goodsVisible: false,
      goodsComponentName: 'Goods-view',
      detailForm: {
        title: '评价内容',
        className: 'wt-section-long-content',
        elements: [
          { name: '评论内容', key: 'evaluation', type: 'editor', disabled: true },
          { name: '评论星级', key: 'score', type: 'custom', disabled: true },
          // { name: '图片', key: 'evaluaImgList', type: 'image', disabled: true },
          { name: '评论时间', key: 'createTime', type: 'text', disabled: true }]
      }
    }
  },
  created() {
    if (this.detailFormData.evaluaImg && this.detailFormData.evaluaImg.length > 0) {
      const _coverList = this.detailFormData.evaluaImg.split(',')
      this.detailFormData.evaluaImgList = []
      for (const item of _coverList) {
        this.detailFormData.evaluaImgList.push({ fileUrl: item })
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    secondBtnsEvents() {

    },
    onButtonAction() {

    },
    deleteEval() {
      this.$wtUtil.deleteConfirm(this, '是否删除?').then(() => {
        request({
          url: '/modules/goodsEvaluation/goodsEvaluationDelete',
          method: 'post',
          data: {
            list: [this.detailFormData.id]
          }
        }).then(res => {
          if (res.code === '0') {
            this.$message({ message: '删除成功', type: 'success' })
            this.$emit('on-dialog-action', 'refresh')
            this.$emit('on-dialog-action', 'close')
          }
        })
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    toClickAction(row) {
      this.$store.dispatch('queryGoodsDetailData', this.detailFormData.goodsId)
      this.goodsVisible = true
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.goodsEvaluation.goodsEvaluationDetailData
    })
  }
}
</script>

<style lang="scss" scoped>
.user-info-card {
  .user-detail {
    background: #fff;
    .user-detail-top {
      display: flex;
      align-items: center;
      padding: 20px;
    }
    .user-detail-photo {
      width: 48px;
      height: 48px;
      border: 1px solid #666;
      border-radius: 50%;
      margin-right: 16px;
    }
    .user-detail-username {
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
      margin-right: 16px;
    }
    .user-detail-level {
      padding: 2px 8px;
      font-size: 12px;
      line-height: 14px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #666;
    }
    .user-detail-bottom {
      display: flex;
      align-items: center;

    }
    .user-detail-label {
      margin-left: 84px;
      color: #989898;
    }
    .user-detail-value {
      color: #666666;
    }
  }
}
.tab-info-title {
  padding: 20px;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
  font-size: 16px;
  font-weight: 600;
  color: #444;
}
.tab-info-title-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;

  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .tab-base-item {
    display: flex;
    align-items: center;
    width: 400px;
    margin-bottom: 20px;
  }
  .tab-base-label {
    width: 100px;
    text-align: right;
    color: #989898;
  }
  .tab-base-value {
    color: #666666;
  }
  .tab-info-content {
    padding: 20px;
  }
}
.tab-info-padding {
  padding: 20px;
}
</style>
<style lang="scss">
.user-info-card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__item.is-active {
      color: #108ee9;
    }
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  .el-tabs {
    margin-top: 20px;
  }
}
.tab-info-card.wt-detail-form {
  .wt-section-title {
    height: 69px;
  }
}
</style>
